import { normilizeMovieReturnValue } from '../supabase/Methods/utils';

// The edge response already includes the public movie record. Reuse it so
// React doesn't replace readable film content with a second loading screen.
export function readFilmBootstrap(slug) {
  if (typeof document === 'undefined') return null;
  try {
    const element = document.getElementById('film-bootstrap');
    if (!element) return null;
    const movie = JSON.parse(element.textContent);
    if (!movie?.id || !movie.title || movie.slug !== slug) return null;
    return normilizeMovieReturnValue([movie])[0];
  } catch { return null; }
}
